import { forwardRef, useStyleConfig, chakra, Box as Box$1, useMultiStyleConfig, Alert as Alert$1, Stack, AlertTitle, AlertDescription, CloseButton, Button as Button$1, Center, Link as Link$1 } from '@chakra-ui/react';
import { useEffect, createContext as createContext$1, useCallback } from 'react';
import _omit from 'ramda/src/omit';
import _pick from 'ramda/src/pick';
import { propNames, layoutPropNames as layoutPropNames$1 } from '@chakra-ui/system';
import _has from 'ramda/src/has';
import warning from 'tiny-warning';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';
import 'ramda/src/fromPairs';
import 'ramda/src/toPairs';
import 'ramda/src/join';
import 'ramda/src/identity';
import 'ramda/src/ifElse';
import _map from 'ramda/src/map';
import 'ramda/src/split';
import 'ramda/src/concat';
import 'ramda/src/toLower';
import 'ramda/src/pipe';
import { colorSchemes } from '@hover/chakra-theme/foundation';
import { includes } from '@hover/utilities';
import { transitions, position, transparentize, border, math } from 'polished';
import { split } from '@chakra-ui/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { theme as theme$1 } from '@hover/chakra-theme';
import { STROKE_ACCENT_CLASS } from '@hover/icons/constants';
import { useReducedMotionConfig, MotionConfig, AnimatePresence, motion } from 'framer-motion';
import { faInfoCircle, faExclamationCircle, faCheckCircle } from '@fortawesome/pro-solid-svg-icons';
import _values from 'ramda/src/values';
import _mapObjIndexed from 'ramda/src/mapObjIndexed';
import { keyframes } from '@emotion/react';
import * as borderTokens from '@hover/tokens-border';
import * as colorTokens from '@hover/tokens-color';
import * as deviceTokens from '@hover/tokens-device';
import * as sizeTokens from '@hover/tokens-size';
import * as spaceTokens from '@hover/tokens-space';
import * as typographyTokens from '@hover/tokens-typography';
import * as depthTokens from '@hover/tokens-depth';
import { createContext } from '@chakra-ui/react-utils';

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}
/**
 * All system props. This is exactly the same as Chakra's
 * `propNames` export, but with a narrower/more accurate type.
 */


var systemPropNames = propNames;
/**
 * List of layout-related system props (layout, space, flexbox, grid
 * and position). This is exactly the same as Chakra's `layoutPropNames`
 * export, but with a narrower/more accurate type.
 */

var layoutPropNames = layoutPropNames$1;
/**
 * Split out layout-related system props from a props object. This is useful
 * when composing components and you want to pass most props to a specific
 * child component, but still want to support the layout APIs via a `Box`
 * or similar container component.
 *
 * @example
 * ```tsx
 * const CompositeComponent = (props: CompositeComponentProps) => {
 *   const { layoutProps, props: childProps } = splitLayoutProps(props);
 *
 *   return (
 *     <Box {...layoutProps}>
 *       <SomeComposedChakraComponent {...childProps} />
 *     </Box>
 *   );
 * }
 * ```
 *
 * @param props all component props
 * @returns an object with the separated props objects
 */

var splitSystemProps = function splitSystemProps(props) {
  return {
    systemProps: _pick(systemPropNames, props),
    props: _omit(systemPropNames, props)
  };
};
/**
 * Split out layout-related system props from a props object. This is useful
 * when composing components and you want to pass most props to a specific
 * child component, but still want to support the layout APIs via a `Box`
 * or similar container component.
 *
 * @example
 * ```tsx
 * const CompositeComponent = (props: CompositeComponentProps) => {
 *   const { layoutProps, props: childProps } = splitLayoutProps(props);
 *
 *   return (
 *     <Box {...layoutProps}>
 *       <SomeComposedChakraComponent {...childProps} />
 *     </Box>
 *   );
 * }
 * ```
 *
 * @param props all component props
 * @returns an object with the separated props objects
 */


var splitLayoutProps = function splitLayoutProps(props) {
  return {
    layoutProps: _pick(layoutPropNames, props),
    props: _omit(layoutPropNames, props)
  };
};
/**
 * Retrieve just the theming props (`variant`, `colorScheme`, `size`, etc.)
 * from a props object.
 *
 * @param props component props
 * @returns theming props from component props (if any)
 */


var pickThemingProps = function pickThemingProps(props) {
  var propNames = ['colorScheme', 'orientation', 'variant', 'size', 'styleConfig'];
  return _pick(propNames, props);
};

var componentMessage = function componentMessage(name, message) {
  return "<".concat(name, "> ").concat(message);
};

var accessibilityMessage = function accessibilityMessage(componentName, message) {
  return componentMessage(componentName, " [\u267F\uFE0F] ".concat(message));
};

var deprecate = function deprecate(deprecated, Component) {
  var WithDeprecation = forwardRef(function (props, ref) {
    useEffect(function () {
      if (!deprecated) return;
      Object.keys(props).forEach(function (propName) {
        var _ref, _Component$displayNam;

        process.env.NODE_ENV !== "production" ? warning(!Object.keys(deprecated).includes(propName) && _has(propName, props), componentMessage((_ref = (_Component$displayNam = Component.displayName) !== null && _Component$displayNam !== void 0 ? _Component$displayNam : Component.name) !== null && _ref !== void 0 ? _ref : 'Unknown', deprecated[propName] || "the `".concat(propName, "` prop is deprecated and will be removed in a future versi on'"))) : void 0;
      });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    Object.keys(deprecated).map( // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    function (deprecatedPropName) {
      return props[deprecatedPropName];
    }));
    return jsx(Component, _objectSpread2(_objectSpread2({}, props), {}, {
      ref: ref
    }));
  });
  WithDeprecation.displayName = Component.displayName;
  return WithDeprecation;
};

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

var _excluded$8 = ["sizes"],
    _excluded2$2 = ["components"];
/**
 * Apply a function to a styled-system responsive prop value
 *
 * @example
 * mapResponsive(value => `${value}px`, 100) // Simple value
 * // 100px
 *
 * mapResponsive(value => `${value}px`, [100, 200]) // Responsive array
 * // ['100px', '200px']
 *
 * mapResponsive(value => `${value}px`, { mobile: 100, desktop: 200 }) // Responsive object
 * // { mobile: '100px', desktop: '200px' }
 *
 * @param fn function to apply to responsive values
 * @param prop responsive prop to map over
 * @param fallback fallback value for handling `null` values in the case of `['foo', 'bar', null]`
 */

var mapResponsive = function mapResponsive(fn, prop, fallback) {
  if (!prop) return prop;
  if (Array.isArray(prop)) return _map(function (p) {
    return p ? fn(p) : fallback !== null && fallback !== void 0 ? fallback : null;
  }, prop);
  if (_typeof(prop) !== 'object') return fn(prop);
  return _mapObjIndexed(fn, prop);
};
/**
 * Apply a reducer to a styled-system responsive prop value
 *
 * @example
 * mapResponsive((a, v) => a + v, 0, 100) // Simple value
 * // 100
 *
 * mapResponsive((a, v) => a + v, 0, [100, 200]) // Responsive array
 * // 300
 *
 * mapResponsive((a, v) => a + v, 0, { mobile: 100, desktop: 200 }) // Responsive object
 * // 300
 *
 * @param fn function to apply to responsive values
 * @param initial initial value for reduce operation
 * @param prop responsive prop to map over
 */


var reduceResponsive = function reduceResponsive(fn, initial, prop) {
  if (!prop) return prop;
  if (Array.isArray(prop)) return prop.reduce(fn, initial);

  if (_typeof(prop) === 'object') {
    // Not sure how to narrow out `T` from `ResponsiveValue<T>`
    return _values(prop).reduce(fn, initial);
  }

  return [prop].reduce(fn, initial);
};

var getResponsiveSizeThemePrefix = function getResponsiveSizeThemePrefix(component) {
  return function (size) {
    return size ? "components.".concat(component, ".responsiveSizes.").concat(size.toString()) : '';
  };
};
/**
 * Helper used to emulate responsive behavior for component size presets
 * described here: https://github.com/chakra-ui/chakra-ui/issues/1028
 *
 * Hopefully we'll get this behavior natively in Chakra from `size`, `variant`
 * etc. soon
 *
 * @example
 * ```tsx
 * // Theme
 * export const Link = {
 *   baseStyle: {},
 *   responsiveSizes: { // <-- instead of `sizes`
 *     small: {
 *       font-size: 12px;
 *       line-height: 18p;
 *     },
 *     large: {
 *       font-size: 18px;
 *       line-height: 26px;
 *     }
 *   }
 * }
 *
 * // Component
 * interface Props {
 *   size: ResponsiveValue<'small' | 'large'>;
 * }
 *
 * const MyLink = (props: Props) =>
 *   <ChakraLink apply={getApplyForResponsiveSize('Link', props.size)} />
 *
 * // Usage
 * <MyLink size={{ mobile: 'small', desktop: 'large' }} />
 * ```
 *
 * @param component component name in theme (used to retrieve styles)
 * @param prop responsive size prop value
 * @returns function to be passed to Chakra's `apply` prop
 */


var getApplyForResponsiveSize = function getApplyForResponsiveSize(component, prop) {
  return prop === undefined ? undefined : mapResponsive(getResponsiveSizeThemePrefix(component), prop);
};
/**
 * Convert a Chakra component theme configuration to support responsive sizes
 *
 * @param theme component theme configuration
 * @returns responsive component theme configuration
 */


var makeComponentResponsive = function makeComponentResponsive(_ref) {
  var sizes = _ref.sizes,
      styles = _objectWithoutProperties(_ref, _excluded$8);

  return _objectSpread2({
    responsiveSizes: sizes
  }, styles);
};
/**
 * Convert specified components on a Chakra theme to suppot responsive sizes
 *
 * @param theme theme to transformm
 * @param componentNames names of components to convert to responsive sizes
 * @returns theme with specified components convertd to responsive sizes
 */


var makeThemeResponsive = function makeThemeResponsive(_ref2, componentNames) {
  var components = _ref2.components,
      theme = _objectWithoutProperties(_ref2, _excluded2$2);

  return _objectSpread2({
    components: _mapObjIndexed(function (styles, name) {
      return componentNames.includes(name) ? makeComponentResponsive(styles) : styles;
    }, components)
  }, theme);
};

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

var _excluded2$1 = ["testId"];
var attribute = 'data-testid';
/**
 * Returns an object containing test ID *attribute* (e.g: `data-testid`)
 *
 * @example
 * const props = { testId: 'foo', bar: 'baz' };
 * <Component {...applyTestId(props)} />
 * // Equivalent
 * <Component data-testid="foo" />
 *
 * @param props - Props object with test ID prop
 *
 * @returns Object with test ID attribute
 */

var applyTestId = function applyTestId(_ref2) {
  var testId = _ref2.testId;
  return _defineProperty({}, attribute, testId);
};
/**
 * Replaces the test ID prop in supplied props object with a test ID *attribute* (e.g: `data-testid`)
 *
 * @example
 * const props = { testId: 'foo', bar: 'baz' };
 * <Component {...withTestId(props)} />
 * // Equivalent
 * <Component data-testid="foo" bar="baz" />
 *
 * @param props - Props object with test ID prop
 *
 * @returns Props object with test ID *attribute* in place of test ID prop
 */


var withTestId = function withTestId(_ref4) {
  var testId = _ref4.testId,
      props = _objectWithoutProperties(_ref4, _excluded2$1);

  return _objectSpread2(_objectSpread2({}, applyTestId({
    testId: testId
  })), props);
};

var _excluded$7 = ["accent", "size", "icon", "orientation", "role", "strokeWidth", "sx", "isInline", "isStatic"];
var Icon = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$accent = _ref.accent,
      accent = _ref$accent === void 0 ? 'currentColor' : _ref$accent,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'small' : _ref$size,
      IconComponent = _ref.icon;
  _ref.orientation;

  var _ref$role = _ref.role,
      role = _ref$role === void 0 ? 'img' : _ref$role,
      strokeWidth = _ref.strokeWidth,
      sx = _ref.sx,
      isInline = _ref.isInline,
      isStatic = _ref.isStatic,
      props = _objectWithoutProperties(_ref, _excluded$7);

  var styles = useStyleConfig('Icon', props);
  var apply = getApplyForResponsiveSize('Icon', size);
  var transition = isStatic ? {} : transitions(['color'], theme$1.motion.easings[250]);
  return jsx(chakra.svg, _objectSpread2(_objectSpread2(_objectSpread2({
    apply: apply,
    "aria-hidden": props.title ? 'false' : 'true',
    as: IconComponent,
    display: isInline ? 'inline' : undefined,
    margin: isInline ? 0 : undefined,
    role: role
  }, transition), withTestId(props)), {}, {
    __css: styles,
    ref: ref,
    sx: _objectSpread2(_objectSpread2({
      strokeWidth: strokeWidth
    }, sx), {}, _defineProperty({}, ".".concat(STROKE_ACCENT_CLASS), {
      stroke: accent
    }))
  }));
});
Icon.displayName = 'Icon';
var _excluded$6 = ["size", "sx", "testId", "isStatic"],
    _excluded2 = ["icon"];
/**
 * List of props we want to support from Font Awesome's icon component
 */

var iconPropNames = ['flip', 'fontSize', 'icon', 'inverse', 'mask', 'rotation', 'spin', 'swapOpacity', 'tabIndex', 'title'];
var AwesomeIcon = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'small' : _ref$size,
      sx = _ref.sx,
      testId = _ref.testId,
      isStatic = _ref.isStatic,
      props = _objectWithoutProperties(_ref, _excluded$6);

  var _split = split(props, [].concat(iconPropNames)),
      _split2 = _slicedToArray(_split, 2),
      _split2$ = _split2[0],
      icon = _split2$.icon,
      iconProps = _objectWithoutProperties(_split2$, _excluded2),
      containerProps = _split2[1];

  var themingProps = pickThemingProps(containerProps);
  var styles = useStyleConfig('Icon', themingProps);

  if ('hoverIcon' in icon) {
    return jsx(Icon, _objectSpread2(_objectSpread2(_objectSpread2({
      icon: icon
    }, containerProps), themingProps), {}, {
      size: size,
      sx: sx,
      testId: testId
    }));
  }

  var apply = getApplyForResponsiveSize('Icon', size);
  var transition = isStatic ? {} : transitions(['color'], theme$1.motion.easings[250]);
  return jsx(Box$1, _objectSpread2(_objectSpread2(_objectSpread2({
    apply: apply,
    position: "relative"
  }, transition), {}, {
    sx: sx
  }, withTestId(_objectSpread2(_objectSpread2({}, containerProps), {}, {
    testId: testId
  }))), {}, {
    __css: styles,
    children: jsx(FontAwesomeIcon, _objectSpread2(_objectSpread2({}, iconProps), {}, {
      forwardedRef: ref,
      icon: icon,
      style: _objectSpread2(_objectSpread2({}, position('absolute', 0, 0, 0, 0)), {}, {
        width: '100%',
        height: '100%'
      })
    }))
  }));
});
AwesomeIcon.displayName = 'AwesomeIcon';

var _createContext = /*#__PURE__*/createContext({
  name: 'ColorSchemeContext',
  strict: false
}),
    _createContext2 = /*#__PURE__*/_slicedToArray(_createContext, 3),
    Provider$1 = _createContext2[0],
    useContext = _createContext2[1];

_createContext2[2];

var useColorScheme = function useColorScheme() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      colorScheme = _ref.colorScheme;

  var context = useContext();
  return _objectSpread2({
    colorScheme: colorScheme
  }, context);
};

var ColorSchemeProvider = function ColorSchemeProvider(_ref2) {
  var colorScheme = _ref2.colorScheme,
      variant = _ref2.variant,
      children = _ref2.children;
  return jsx(Provider$1, {
    value: {
      colorScheme: typeof colorScheme === 'string' && includes(colorSchemes, colorScheme) ? colorScheme : undefined,
      variant: variant
    },
    children: children
  });
};

var _excluded$5 = ["children", "icon", "onCloseClick", "showClose", "showIcon", "title"];
var iconMap = {
  info: faInfoCircle,
  warning: faExclamationCircle,
  error: faExclamationCircle,
  success: faCheckCircle
};
var colorMap = {
  info: 'primary',
  success: 'success',
  warning: 'warning',
  error: 'danger'
};
var Alert = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      icon = _ref.icon,
      onCloseClick = _ref.onCloseClick,
      _ref$showClose = _ref.showClose,
      showClose = _ref$showClose === void 0 ? false : _ref$showClose,
      _ref$showIcon = _ref.showIcon,
      showIcon = _ref$showIcon === void 0 ? true : _ref$showIcon,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded$5);

  var styles = useMultiStyleConfig('Alert', props);
  var _props$status = props.status,
      status = _props$status === void 0 ? 'info' : _props$status;
  var colorScheme = colorMap[status];
  return jsxs(Alert$1, _objectSpread2(_objectSpread2({}, withTestId(props)), {}, {
    ref: ref,
    children: [showIcon && jsx(AwesomeIcon, {
      icon: icon !== null && icon !== void 0 ? icon : iconMap[status],
      sx: _objectSpread2(_objectSpread2({}, styles.icon), title ? styles.titleIcon : {})
    }), jsxs(ColorSchemeProvider, {
      colorScheme: colorScheme,
      variant: "dark",
      children: [jsxs(Stack, {
        direction: "column",
        flex: "1",
        spacing: "0",
        children: [title && jsx(AlertTitle, {
          children: title
        }), jsx(AlertDescription, {
          children: children
        })]
      }), showClose && jsx(CloseButton, {
        colorScheme: colorScheme,
        onClick: onCloseClick
      })]
    })]
  }));
});
Alert.displayName = 'Alert';
/**
 * Whether to disable layout animations based on user preference or
 * environment.
 *
 * Both Chakra and Framer Motion expose hooks to read the user preference from
 * CSS, but this should be the canonical hook that we use as there are other
 * cases to consider (like screenshots in Chromatic).
 */

var useIsMotionReduced = function useIsMotionReduced() {
  return (// This reads from _both_ the CSS value, and the context value set via
    // `MotionConfig`, which allows us to set `reducedMotion="always"` in a
    // `MotionConfig` that wraps every story to disable motion in Chromatic.
    useReducedMotionConfig()
  );
};
/**
 * Generates a `box-shadow` CSS property
 *
 * @example
 * boxShadow('#ff0000', 0.75, '1px', '1px', '3px');
 * // '1px 1px 3px rgba(255, 0, 0, 0.75)'
 *
 * @param color - shadow color
 * @param opacity - opacity to be applied to shadow color
 * @param values - remaining shadow values in the same order as CSS spec
 */


var boxShadow = function boxShadow(color, opacity) {
  for (var _len = arguments.length, values = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    values[_key - 2] = arguments[_key];
  }

  return values.concat(transparentize(1 - opacity, color)).join(' ');
};

var shadows = {
  distance500: /*#__PURE__*/boxShadow(depthTokens.distance500Color, depthTokens.distance500Opacity, depthTokens.distance500OffsetX, depthTokens.distance500OffsetY, depthTokens.distance500BlurRadius, depthTokens.distance500SpreadRadius),
  distance600: /*#__PURE__*/boxShadow(depthTokens.distance600Color, depthTokens.distance600Opacity, depthTokens.distance600OffsetX, depthTokens.distance600OffsetY, depthTokens.distance600BlurRadius, depthTokens.distance600SpreadRadius),
  glowPrimary: /*#__PURE__*/boxShadow(depthTokens.glowPrimaryColor, depthTokens.glowPrimaryOpacity, depthTokens.glowPrimaryOffsetX, depthTokens.glowPrimaryOffsetY, depthTokens.glowPrimaryBlurRadius, depthTokens.glowPrimarySpreadRadius),
  glowDanger: /*#__PURE__*/boxShadow(depthTokens.glowDangerColor, depthTokens.glowDangerOpacity, depthTokens.glowDangerOffsetX, depthTokens.glowDangerOffsetY, depthTokens.glowDangerBlurRadius, depthTokens.glowDangerSpreadRadius)
};
var borderStyle = 'solid';
var neutral = {
  borderWidth: borderTokens.width400,
  borderRadius: borderTokens.radius300,
  borderColor: borderTokens.colorNeutral,
  borderStyle: borderStyle
};
var primary = {
  borderWidth: borderTokens.width400,
  borderRadius: borderTokens.radius300,
  borderColor: borderTokens.colorPrimary,
  borderStyle: borderStyle
};
var danger = {
  borderWidth: borderTokens.width400,
  borderRadius: borderTokens.radius300,
  borderColor: borderTokens.colorDanger,
  borderStyle: borderStyle
};
var borderPresets = {
  neutral: neutral,
  primary: primary,
  danger: danger,
  idle: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, neutral), {}, {
    boxShadow: /*#__PURE__*/[boxShadow(borderTokens.colorNeutral, 0, '0px 0px'), boxShadow(borderTokens.colorNeutral, 0, 'inset 0px 0px 0px 1px')].join(',')
  }),
  focus: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, primary), {}, {
    boxShadow: /*#__PURE__*/[shadows.glowPrimary, boxShadow(borderTokens.colorPrimary, 0.5, 'inset 0px 0px 0px 1px')].join(',')
  }),
  invalid: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, danger), {}, {
    boxShadow: /*#__PURE__*/[shadows.glowDanger, boxShadow(borderTokens.colorDanger, 0, 'inset 0px 0px 0px 1px')].join(',')
  }),
  invalidFocus: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, danger), {}, {
    boxShadow: /*#__PURE__*/[shadows.glowDanger, boxShadow(borderTokens.colorDanger, 0.5, 'inset 0px 0px 0px 1px')].join(',')
  })
};

var fromPreset = function fromPreset(preset) {
  return (// eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    "".concat(preset.borderWidth, " solid ").concat(preset.borderColor)
  );
};

var borders = {
  primary: /*#__PURE__*/fromPreset(borderPresets.primary),
  neutral: /*#__PURE__*/fromPreset(borderPresets.neutral),
  danger: /*#__PURE__*/fromPreset(borderPresets.danger)
};
var spread = '2px';

var expand = function expand() {
  var modifier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '0px';
  return position(math("-1 * ((".concat(borderTokens.width500, " + ").concat(spread, ") + ").concat(modifier, "px)")));
};
/**
 * Applies position properties to focus border in the `:focus` state.  The
 * default focus state expands the border 2px beyond the outside of the element
 * taking into account the width of the focus border itself. This can be
 * customized using the modifier parameter.
 *
 * @param modifier - Number of pixels to add or subtract from expanded distance,
 * for example -1px to contract the border or 1px to expand it further
 *
 * @returns CSS object to be applied to the element receiving focus
 */


var focusDistance = function focusDistance(modifier) {
  return {
    ':focus:before': expand(modifier)
  };
};
/**
 * Applies border radius property to focus border in the `:focus` state. The
 * default focus state inherits the border radius property from the element.
 *
 * @param radius - Border radius to apply
 *
 * @returns CSS object to be applied to the element receiving focus
 */


var focusRadius = function focusRadius(radius) {
  return {
    ':focus:before': {
      borderRadius: radius
    }
  };
};

var focus = {
  position: 'relative',
  ':before': /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({
    position: 'absolute',
    content: "''",
    borderRadius: 'inherit',
    opacity: 0
  }, /*#__PURE__*/position(0)), /*#__PURE__*/border(borderTokens.width500, 'solid', colorTokens.primary400)), /*#__PURE__*/transitions(['top', ' bottom', ' right', ' left', ' opacity', 'border-radius'], // TODO: replace with a token
  '250ms ease-out')),
  ':focus:before': /*#__PURE__*/_objectSpread2({
    opacity: 1
  }, /*#__PURE__*/expand()),
  ':focus': {
    outline: 0
  },
  '::-moz-focus-inner': {
    border: 0
  }
};

var forKeys = function forKeys(keys, css) {
  return keys.map(function (k) {
    return _defineProperty({}, k, css);
  }).reduce(function (acc, value) {
    return _objectSpread2(_objectSpread2({}, acc), value);
  });
};

var shapes = {
  solid: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, /*#__PURE__*/forKeys(['pill', 'circle'], {
    borderRadius: borderTokens.radius900
  })), /*#__PURE__*/forKeys(['box', 'square'], /*#__PURE__*/_objectSpread2({
    borderRadius: borderTokens.radius300
  }, /*#__PURE__*/focusRadius( /*#__PURE__*/math( /*#__PURE__*/"".concat(borderTokens.radius300, " * 2")))))),
  outline: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, /*#__PURE__*/forKeys(['pill', 'circle'], {
    borderRadius: borderTokens.radius900
  })), /*#__PURE__*/forKeys(['box', 'square'], /*#__PURE__*/_objectSpread2({
    borderRadius: borderTokens.radius300
  }, /*#__PURE__*/focusRadius( /*#__PURE__*/math( /*#__PURE__*/"".concat(borderTokens.radius300, " * 2")))))),
  minimal: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, /*#__PURE__*/forKeys(['pill', 'circle'], /*#__PURE__*/_objectSpread2({
    borderRadius: borderTokens.radius900
  }, /*#__PURE__*/focusDistance('-3px')))), /*#__PURE__*/forKeys(['box', 'square'], /*#__PURE__*/_objectSpread2({
    borderRadius: borderTokens.radius300
  }, /*#__PURE__*/focusDistance('-3px'))))
};
var fills = {
  solid: {
    borderStyle: 'none'
  },
  outline: /*#__PURE__*/_objectSpread2({
    borderStyle: 'solid',
    borderWidth: borderTokens.width400,
    borderColor: 'currentcolor',
    backgroundColor: 'transparent'
  }, /*#__PURE__*/focusDistance(borderTokens.width400)),
  minimal: {
    borderStyle: 'none',
    backgroundColor: 'transparent'
  }
};

var sizes$1 = /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, /*#__PURE__*/forKeys(['box', 'pill'], {
  "default": {
    paddingLeft: spaceTokens.size500,
    paddingRight: spaceTokens.size500,
    fontSize: typographyTokens.size400,
    lineHeight: typographyTokens.height400,
    fontWeight: typographyTokens.weight700,
    height: sizeTokens.size300
  },
  large: {
    paddingLeft: spaceTokens.size600,
    paddingRight: spaceTokens.size600,
    fontSize: typographyTokens.size400,
    lineHeight: typographyTokens.height400,
    fontWeight: typographyTokens.weight700,
    height: sizeTokens.size400
  }
})), /*#__PURE__*/forKeys(['square', 'circle'], {
  "default": {
    padding: spaceTokens.size0,
    width: sizeTokens.size300,
    height: sizeTokens.size300
  },
  large: {
    padding: spaceTokens.size0,
    width: sizeTokens.size400,
    height: sizeTokens.size400
  }
}));

var colors$1 = {
  solid: {
    primary: {
      color: colorTokens.neutral0,
      backgroundColor: colorTokens.primary600,
      ':hover:not([disabled])': {
        backgroundColor: colorTokens.primary700
      },
      ':active:not([disabled])': {
        backgroundColor: colorTokens.primary800
      }
    },
    danger: {
      color: colorTokens.neutral0,
      backgroundColor: colorTokens.danger500,
      ':hover:not([disabled])': {
        backgroundColor: colorTokens.danger600
      },
      ':active:not([disabled])': {
        backgroundColor: colorTokens.danger700
      }
    },
    success: {
      color: colorTokens.neutral0,
      backgroundColor: colorTokens.success500,
      ':hover:not([disabled])': {
        backgroundColor: colorTokens.success600
      },
      ':active:not([disabled])': {
        backgroundColor: colorTokens.success700
      }
    },
    disabled: {
      backgroundColor: colorTokens.neutral200,
      color: colorTokens.neutral500
    }
  },
  outline: {
    primary: {
      color: colorTokens.primary600,
      boxShadow: /*#__PURE__*/"inset 0px 0px 0px 1px ".concat( /*#__PURE__*/transparentize(1, colorTokens.primary600)),
      ':hover:not([disabled])': {
        color: colorTokens.primary700,
        backgroundColor: colorTokens.primary100,
        boxShadow: /*#__PURE__*/"inset 0px 0px 0px 1px ".concat(colorTokens.primary700)
      },
      ':active:not([disabled])': {
        color: colorTokens.primary800,
        backgroundColor: colorTokens.primary200,
        boxShadow: /*#__PURE__*/"inset 0px 0px 0px 1px ".concat(colorTokens.primary800)
      }
    },
    danger: {
      color: colorTokens.danger500,
      boxShadow: /*#__PURE__*/"inset 0px 0px 0px 1px ".concat( /*#__PURE__*/transparentize(1, colorTokens.danger500)),
      ':hover:not([disabled])': {
        color: colorTokens.danger600,
        backgroundColor: colorTokens.danger100,
        boxShadow: /*#__PURE__*/"inset 0px 0px 0px 1px ".concat(colorTokens.danger600)
      },
      ':active:not([disabled])': {
        color: colorTokens.danger700,
        backgroundColor: colorTokens.danger200,
        boxShadow: /*#__PURE__*/"inset 0px 0px 0px 1px ".concat(colorTokens.danger700)
      }
    },
    success: {
      color: colorTokens.success500,
      boxShadow: /*#__PURE__*/"inset 0px 0px 0px 1px ".concat( /*#__PURE__*/transparentize(1, colorTokens.success500)),
      ':hover:not([disabled])': {
        color: colorTokens.success600,
        backgroundColor: colorTokens.success100,
        boxShadow: /*#__PURE__*/"inset 0px 0px 0px 1px ".concat(colorTokens.success600)
      },
      ':active:not([disabled])': {
        color: colorTokens.success700,
        backgroundColor: colorTokens.success200,
        boxShadow: /*#__PURE__*/"inset 0px 0px 0px 1px ".concat(colorTokens.success700)
      }
    },
    disabled: {
      color: colorTokens.neutral500,
      borderColor: colorTokens.neutral200
    }
  },
  minimal: {
    primary: {
      color: colorTokens.primary600,
      ':hover:not([disabled])': {
        color: colorTokens.primary700,
        backgroundColor: colorTokens.primary100
      },
      ':active:not([disabled])': {
        color: colorTokens.primary800,
        backgroundColor: colorTokens.primary200
      }
    },
    danger: {
      color: colorTokens.danger500,
      ':hover:not([disabled])': {
        color: colorTokens.danger600,
        backgroundColor: colorTokens.danger100
      },
      ':active:not([disabled])': {
        color: colorTokens.danger700,
        backgroundColor: colorTokens.danger200
      }
    },
    success: {
      color: colorTokens.success500,
      ':hover:not([disabled])': {
        color: colorTokens.success600,
        backgroundColor: colorTokens.success100
      },
      ':active:not([disabled])': {
        color: colorTokens.success700,
        backgroundColor: colorTokens.success200
      }
    },
    disabled: {
      color: colorTokens.neutral500,
      borderColor: colorTokens.neutral200
    }
  }
};
var buttonStyles = /*#__PURE__*/Object.freeze({
  __proto__: null,
  shapes: shapes,
  fills: fills,
  sizes: sizes$1,
  colors: colors$1
});
var headingStyles = {
  '200': {
    fontSize: typographyTokens.heading200Size,
    fontWeight: typographyTokens.heading200Weight,
    lineHeight: typographyTokens.heading200Height,
    color: typographyTokens.heading200Color
  },
  '300': {
    fontSize: typographyTokens.heading300Size,
    fontWeight: typographyTokens.heading300Weight,
    lineHeight: typographyTokens.heading300Height,
    color: typographyTokens.heading300Color
  },
  '400': {
    fontSize: typographyTokens.heading400Size,
    fontWeight: typographyTokens.heading400Weight,
    lineHeight: typographyTokens.heading400Height,
    color: typographyTokens.heading400Color
  },
  '500': {
    fontSize: typographyTokens.heading500Size,
    fontWeight: typographyTokens.heading500Weight,
    lineHeight: typographyTokens.heading500Height,
    color: typographyTokens.heading500Color
  },
  '600': {
    fontSize: typographyTokens.heading600Size,
    fontWeight: typographyTokens.heading600Weight,
    lineHeight: typographyTokens.heading600Height,
    color: typographyTokens.heading600Color
  },
  '650': {
    fontSize: typographyTokens.heading650Size,
    fontWeight: typographyTokens.heading650Weight,
    lineHeight: typographyTokens.heading650Height,
    color: typographyTokens.heading600Color
  },
  '700': {
    fontSize: typographyTokens.heading700Size,
    fontWeight: typographyTokens.heading700Weight,
    lineHeight: typographyTokens.heading700Height,
    color: typographyTokens.heading700Color
  }
};
var textStyles = {
  '200': {
    fontSize: typographyTokens.body200Size,
    fontWeight: typographyTokens.body200Weight,
    lineHeight: typographyTokens.body200Height,
    color: typographyTokens.body200Color
  },
  '300': {
    fontSize: typographyTokens.body300Size,
    fontWeight: typographyTokens.body300Weight,
    lineHeight: typographyTokens.body300Height,
    color: typographyTokens.body300Color
  },
  '400': {
    fontSize: typographyTokens.body400Size,
    fontWeight: typographyTokens.body400Weight,
    lineHeight: typographyTokens.body400Height,
    color: typographyTokens.body400Color
  },
  '500': {
    fontSize: typographyTokens.body500Size,
    fontWeight: typographyTokens.body500Weight,
    lineHeight: typographyTokens.body500Height,
    color: typographyTokens.body500Color
  },
  '600': {
    fontSize: typographyTokens.body600Size,
    fontWeight: typographyTokens.body600Weight,
    lineHeight: typographyTokens.body600Height,
    color: typographyTokens.body600Color
  }
};

var colors = /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, colorTokens), {}, {
  neutral000: colorTokens.neutral0,
  inherit: 'inherit'
});

var sizes = sizeTokens;
var breakpoints = {
  '100': deviceTokens.breakpointWidth100,
  '200': deviceTokens.breakpointWidth200,
  '300': deviceTokens.breakpointWidth300,
  '400': deviceTokens.breakpointWidth400,
  '500': deviceTokens.breakpointWidth500,
  "default": '',
  desktop: deviceTokens.breakpointWidthDesktop,
  mobile: deviceTokens.breakpointWidthMobile,
  tablet: deviceTokens.breakpointWidthTablet
};
var radii = {
  '200': borderTokens.radius200,
  '300': borderTokens.radius300,
  '400': borderTokens.radius400,
  '500': borderTokens.radius500,
  '900': borderTokens.radius900,
  round: borderTokens.radiusRound
};
var borderWidths = {
  '0': borderTokens.width0,
  '400': borderTokens.width400,
  '500': borderTokens.width500
};
var space = {
  '0': spaceTokens.size0,
  '50': spaceTokens.size50,
  '100': spaceTokens.size100,
  '200': spaceTokens.size200,
  '300': spaceTokens.size300,
  '400': spaceTokens.size400,
  '500': spaceTokens.size500,
  '600': spaceTokens.size600,
  '700': spaceTokens.size700,
  '800': spaceTokens.size800,
  '900': spaceTokens.size900,
  '1000': spaceTokens.size1000,
  '1100': spaceTokens.size1100
};
var fonts = {
  body: typographyTokens.familyBody,
  brand: typographyTokens.familyBrand,
  code: typographyTokens.familyCode,
  display: typographyTokens.familyDisplay
};
var fontSizes = {
  '50': typographyTokens.size50,
  '100': typographyTokens.size100,
  '200': typographyTokens.size200,
  '300': typographyTokens.size300,
  '400': typographyTokens.size400,
  '500': typographyTokens.size500,
  '600': typographyTokens.size600,
  '700': typographyTokens.size700,
  '800': typographyTokens.size800,
  '900': typographyTokens.size900,
  '1000': typographyTokens.size1000,
  base: typographyTokens.sizeBase
};
var lineHeights = {
  '50': typographyTokens.height50,
  '100': typographyTokens.height100,
  '200': typographyTokens.height200,
  '300': typographyTokens.height300,
  '400': typographyTokens.height400,
  '500': typographyTokens.height500,
  '600': typographyTokens.height600,
  '700': typographyTokens.height700,
  '800': typographyTokens.height800,
  '900': typographyTokens.height900,
  '1000': typographyTokens.height1000
};
var fontWeights = {
  '100': typographyTokens.weight100,
  '300': typographyTokens.weight300,
  '400': typographyTokens.weight400,
  '500': typographyTokens.weight500,
  '600': typographyTokens.weight600,
  '700': typographyTokens.weight700,
  body: typographyTokens.weightBody,
  bodyBold: typographyTokens.weightBodyBold,
  bodySemiBold: typographyTokens.weightBodySemiBold,
  display: typographyTokens.weightDisplay,
  heading: typographyTokens.weightHeading,
  headingLight: typographyTokens.weightHeadingLight
};
var theme = {
  buttonStyles: buttonStyles,
  breakpoints: breakpoints,
  colors: colors,
  borderWidths: borderWidths,
  radii: radii,
  sizes: sizes,
  space: space,
  fonts: fonts,
  fontSizes: fontSizes,
  lineHeights: lineHeights,
  fontWeights: fontWeights,
  borders: borders,
  borderPresets: borderPresets,
  focus: focus,
  textStyles: textStyles,
  headingStyles: headingStyles,
  shadows: shadows
};
var ThemeContext = /*#__PURE__*/createContext$1({
  theme: theme
});
var Provider = ThemeContext.Provider;
var _excluded$4 = ["children", "element", "as"];
var Box = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      element = _ref.element,
      as = _ref.as,
      props = _objectWithoutProperties(_ref, _excluded$4);

  return jsx(Box$1, _objectSpread2(_objectSpread2({
    as: element !== null && element !== void 0 ? element : as,
    boxSizing: "border-box",
    display: "flex"
  }, withTestId(props)), {}, {
    ref: ref,
    children: children
  }));
});
Box.displayName = 'Box'; // TODO(1.0): 1.0 remove `element` entirely

var BoxWithDeprecationWarning = /*#__PURE__*/deprecate(process.env.NODE_ENV !== "production" && {
  element: 'the `element` prop is deprecated, use `as`'
}, Box);

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
/* eslint-disable @typescript-eslint/no-redeclare */


var Copy = {
  LOADING: 'Loading'
};
var ProgressBarValue = {
  MAX: 100,
  MIN: 0
};
var _excluded$3 = ["label", "color", "speed", "size"];

var _templateObject;

var durations = {
  500: 2,
  700: 0.75
};
var spin = /*#__PURE__*/keyframes(_templateObject || (_templateObject = /*#__PURE__*/_taggedTemplateLiteral(["\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n"])));
var Loader = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$label = _ref.label,
      label = _ref$label === void 0 ? Copy.LOADING : _ref$label,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'primary.600' : _ref$color,
      _ref$speed = _ref.speed,
      speed = _ref$speed === void 0 ? 500 : _ref$speed,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'small' : _ref$size,
      props = _objectWithoutProperties(_ref, _excluded$3);

  var styles = useStyleConfig('Icon', _objectSpread2({
    size: size
  }, props));
  var apply = getApplyForResponsiveSize('Icon', size);
  return jsx(BoxWithDeprecationWarning, _objectSpread2(_objectSpread2({}, withTestId(props)), {}, {
    alignContent: "center",
    "aria-busy": true,
    "aria-label": label,
    "aria-valuemax": ProgressBarValue.MAX,
    "aria-valuemin": ProgressBarValue.MIN,
    color: color,
    justifyContent: "center",
    ref: ref,
    role: "progressbar",
    children: jsxs(chakra.svg, {
      animation: "".concat(durations[speed], "s linear 0s infinite normal none running ").concat(spin),
      apply: apply,
      "aria-hidden": "true",
      focusable: "false",
      role: "img",
      sx: styles,
      viewBox: "0 0 512 512",
      xmlns: "http://www.w3.org/2000/svg",
      children: [jsx("path", {
        d: "M478.71 364.58zm-22 6.11l-27.83-15.9a15.92 15.92 0 0 1-6.94-19.2A184 184 0 1 1 256 72c5.89 0 11.71.29 17.46.83-.74-.07-1.48-.15-2.23-.21-8.49-.69-15.23-7.31-15.23-15.83v-32a16 16 0 0 1 15.34-16C266.24 8.46 261.18 8 256 8 119 8 8 119 8 256s111 248 248 248c98 0 182.42-56.95 222.71-139.42-4.13 7.86-14.23 10.55-22 6.11z",
        fill: "currentColor",
        opacity: 0.4
      }), jsx("path", {
        d: "M271.23 72.62c-8.49-.69-15.23-7.31-15.23-15.83V24.73c0-9.11 7.67-16.78 16.77-16.17C401.92 17.18 504 124.67 504 256a246 246 0 0 1-25 108.24c-4 8.17-14.37 11-22.26 6.45l-27.84-15.9c-7.41-4.23-9.83-13.35-6.2-21.07A182.53 182.53 0 0 0 440 256c0-96.49-74.27-175.63-168.77-183.38z",
        fill: "currentColor"
      })]
    })
  }));
});
var _excluded$2 = ["children", "color", "disabled", "fill", "iconAfter", "isDisabled", "isLoading", "iconBefore", "label", "loading", "onPress", "onClick", "shape", "size"];
var MotionCenter = /*#__PURE__*/motion(Center);
var MotionLoader = /*#__PURE__*/motion(Loader);
var iconSizes = {
  small: 'tiny',
  "default": 'small',
  medium: 'small',
  large: 'small'
};
var loaderSizes = {
  small: 'tiny',
  "default": 'small',
  medium: 'small',
  large: 'medium'
};

var transformForFill = function transformForFill(translate, transform) {
  return translate ? {
    transform: transform
  } : {};
};

var getVariants = function getVariants(translate, loader) {
  return {
    loading: _objectSpread2({
      opacity: loader ? 1 : 0
    }, transformForFill(translate, "translate3d(0, ".concat(loader ? 0 : -100, "%, 0)"))),
    idle: _objectSpread2({
      opacity: loader ? 0 : 1
    }, transformForFill(translate, "translate3d(0, ".concat(loader ? 100 : 0, "%, 0)")))
  };
};

var Button = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'primary' : _ref$color,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? 'solid' : _ref$fill,
      iconAfter = _ref.iconAfter,
      isDisabledProp = _ref.isDisabled,
      isLoadingProp = _ref.isLoading,
      iconBefore = _ref.iconBefore,
      label = _ref.label,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      onPress = _ref.onPress,
      onClickProp = _ref.onClick,
      _ref$shape = _ref.shape,
      shape = _ref$shape === void 0 ? 'pill' : _ref$shape,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'default' : _ref$size,
      props = _objectWithoutProperties(_ref, _excluded$2);

  var isDisabled = isDisabledProp !== null && isDisabledProp !== void 0 ? isDisabledProp : disabled;
  var isLoading = isLoadingProp !== null && isLoadingProp !== void 0 ? isLoadingProp : loading;
  var onClick = onClickProp !== null && onClickProp !== void 0 ? onClickProp : onPress;
  var isMotionReduced = useIsMotionReduced();
  var shouldSlide = fill !== 'minimal' && !isMotionReduced;
  var ariaLabel = label !== null && label !== void 0 ? label : typeof children === 'string' ? children : undefined;
  process.env.NODE_ENV !== "production" ? warning(!!ariaLabel, accessibilityMessage('Button', 'a label is required when children is not a string')) : void 0;
  var isEqual = shape === 'circle' || shape === 'square';
  var applySize = getApplyForResponsiveSize('Button', size);
  var applyEqualSize = mapResponsive(function (s) {
    return s ? "components.Button.equalSizes.".concat(s) : '';
  }, size);
  var iconSize = mapResponsive(function (s) {
    return iconSizes[s];
  }, size, 'small');
  var loaderSize = mapResponsive(function (s) {
    return loaderSizes[s];
  }, size, 'small');
  return jsx(Button$1, _objectSpread2(_objectSpread2({
    apply: isEqual ? applyEqualSize : applySize,
    "aria-label": ariaLabel,
    colorScheme: color,
    disabled: isDisabled || isLoading,
    isDisabled: isDisabled,
    onClick: onClick,
    shape: shape,
    size: "",
    variant: "".concat(fill, "-").concat(shape)
  }, withTestId(props)), {}, {
    ref: ref,
    children: jsxs(MotionConfig, {
      transition: theme$1.motion.framer.tight,
      children: [jsxs(MotionCenter, _objectSpread2(_objectSpread2({}, applyTestId({
        testId: 'wrapper'
      })), {}, {
        animate: isLoading ? 'loading' : 'idle',
        height: "100%",
        variants: getVariants(shouldSlide, false),
        width: "100%",
        children: [iconBefore && jsx(AwesomeIcon, {
          icon: iconBefore,
          marginLeft: 0,
          marginRight: 200,
          marginY: 0,
          size: iconSize
        }), children, iconAfter && jsx(AwesomeIcon, {
          icon: iconAfter,
          marginLeft: 200,
          marginRight: 0,
          marginY: 0,
          size: iconSize
        })]
      })), jsx(AnimatePresence, {
        children: isLoading && jsx(MotionLoader, {
          animate: "loading",
          color: "inherit",
          exit: "idle",
          initial: "idle",
          position: "absolute",
          size: loaderSize,
          variants: getVariants(shouldSlide, true)
        })
      })]
    })
  }));
});
Button.displayName = 'Button'; // TODO(1.0): 1.0 remove `disabled`, `loading` and `onPress` entirely

var ButtonWithDeprecationWarning = /*#__PURE__*/deprecate(process.env.NODE_ENV !== "production" && {
  disabled: 'the `disabled` prop is deprecated, use `isDisabled`',
  loading: 'the `loading` prop is deprecated, use `isLoading`',
  onPress: 'the `onPress` prop is deprecated, use `onClick`'
}, Button);
var _excluded$1 = ["icon", "iconSize", "shape", "size"];
var IconButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var icon = _ref.icon,
      iconSize = _ref.iconSize,
      _ref$shape = _ref.shape,
      shape = _ref$shape === void 0 ? 'circle' : _ref$shape,
      size = _ref.size,
      props = _objectWithoutProperties(_ref, _excluded$1);

  return jsx(ButtonWithDeprecationWarning, _objectSpread2(_objectSpread2({
    shape: shape,
    size: size
  }, props), {}, {
    ref: ref,
    children: jsx(AwesomeIcon, {
      icon: icon,
      size: iconSize !== null && iconSize !== void 0 ? iconSize : mapResponsive(function (s) {
        return s ? iconSizes[s] : 'small';
      }, size)
    })
  }));
});
IconButton.displayName = 'IconButton';
var _excluded = ["children", "isMinimal", "label", "onChange", "onPress", "size"];
var Link = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _props$colorScheme;

  var children = _ref.children,
      _ref$isMinimal = _ref.isMinimal,
      isMinimal = _ref$isMinimal === void 0 ? false : _ref$isMinimal,
      label = _ref.label,
      onChange = _ref.onChange,
      onPress = _ref.onPress,
      size = _ref.size,
      props = _objectWithoutProperties(_ref, _excluded);

  var onClick = useCallback(function (event) {
    onChange === null || onChange === void 0 ? void 0 : onChange(event);
    if (!props.disabled) onPress === null || onPress === void 0 ? void 0 : onPress(event);
  }, [onChange, props.disabled, onPress]);
  var apply = getApplyForResponsiveSize('Link', size);
  return jsx(Link$1, _objectSpread2(_objectSpread2({
    "aria-label": label,
    onClick: onClick
  }, withTestId(props)), {}, {
    apply: apply,
    ref: ref,
    variant: isMinimal ? 'minimal' : 'underline',
    children: jsx(ColorSchemeProvider, {
      colorScheme: (_props$colorScheme = props.colorScheme) !== null && _props$colorScheme !== void 0 ? _props$colorScheme : 'primary',
      children: children
    })
  }));
});
Link.displayName = 'Link';
export { Alert as A, BoxWithDeprecationWarning as B, ColorSchemeProvider as C, Icon as I, Loader as L, Provider as P, ThemeContext as T, _slicedToArray as _, _objectSpread2 as a, _objectWithoutProperties as b, componentMessage as c, AwesomeIcon as d, ButtonWithDeprecationWarning as e, IconButton as f, Link as g, useIsMotionReduced as h, splitSystemProps as i, systemPropNames as j, _arrayLikeToArray as k, layoutPropNames as l, _unsupportedIterableToArray as m, getApplyForResponsiveSize as n, mapResponsive as o, deprecate as p, pickThemingProps as q, reduceResponsive as r, splitLayoutProps as s, theme as t, useColorScheme as u, _defineProperty as v, withTestId as w, makeThemeResponsive as x, _taggedTemplateLiteral as y, getVariants as z };